import React from 'react';

function CrmTableStateRow({
  loading,
  error,
  isEmpty,
  colSpan,
  loadingMessage = 'Loading...',
  emptyMessage = 'No records found.',
}) {
  if (loading) {
    return (
      <tr>
        <td colSpan={colSpan} className="text-center text-muted py-4">
          {loadingMessage}
        </td>
      </tr>
    );
  }

  if (error) {
    return (
      <tr>
        <td colSpan={colSpan} className="text-center text-danger py-4">
          {typeof error === 'string' ? error : 'Something went wrong.'}
        </td>
      </tr>
    );
  }

  if (isEmpty) {
    return (
      <tr>
        <td colSpan={colSpan} className="text-center text-muted py-4">
          {emptyMessage}
        </td>
      </tr>
    );
  }

  return null;
}

export default CrmTableStateRow;
